function stripDiacritics(str: string) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function placeholderVideoRenderName() {
  const date = new Date();
  const formattedDate = date.toISOString().slice(0, 19).replace(/[-:]/g, "");

  return `amplifiles-video-${formattedDate}`;
}

export function safeFilename(filename: string) {
  return stripDiacritics(filename)
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9()\-_]/g, "-");
}
